// Row id under dataKey as a string, or null when the row has no usable id.
// String() so numeric and string ids compare equal.
export const getRowId = (row: any, dataKey: string): string | null => {
  const id = row?.[dataKey];
  if (id === undefined || id === null) return null;
  return String(id);
};
